import actionTypes from "../actionTypes";

const fetch = () => {
  return {
    type: actionTypes.invoices.FETCH
  };
}

const fetchOk = (data) => {
  return {
    type: actionTypes.invoices.FETCH_OK,
    data: data
  };
}

const fetchError = (error) => {
  return {
    type: actionTypes.invoices.FETCH_ERROR,
    error: error
  };
}

const fetchMore = () => {
  return {
    type: actionTypes.invoices.FETCH_MORE
  };
}

export const invoicesActions = {
  fetch,
  fetchOk,
  fetchError,
  fetchMore
}